<template>
	<div class="mapBox">
		<div class="map">
			<div class="mapGoogle" id="map"></div>
		</div>
	</div>
</template>
<script>
	import centerImg from "./img/center1.png"
	export default{
		data(){
			return {
				mapNode:null
			}
		},
		mounted(){	
			var center={lat:Number(this.$route.query.lat),lng:Number(this.$route.query.lng)}
			this.init(center)
		},
		methods:{
			init(center){//初始化地图
		        //中心点设置
		        var _this=this;
		        var center=center?center:{lat: 39.916666666666664, lng: 116.383333}
				this.mapNode = new google.maps.Map(document.getElementById('map'), {
				  center,
				  minZoom:2,
				  zoom: 11
				});	
				this.fuCoordinates(center)
			},
			fuCoordinates(city){
				var city=city?city:{lat: 39.916666666666664, lng: 116.383333}
		          var marker = new google.maps.Marker({
		            position: new google.maps.LatLng(city.lat, city.lng),
		            icon: centerImg,
		            map: this.mapNode,
		            title: '标记'
		          });	
			}
		}
	}
</script>
<style>	
	/* body{zoom: 1;height: 100%;width: 100%;min-width: 100vw;} */
	.gm-style-mtc ,.gm-svpc{display: none;}
	.gm-control-active,.gm-fullscreen-control{display: none;}	
</style>
<style scoped="scoped">
	* {box-sizing: border-box;}
	.map{width: 100vw;height: 100vh;position: relative;color: #333;}
	.map >.mapGoogle{height: 100%;width: 100%;overflow: hidden;}
	
</style>


// WEBPACK FOOTER //
// src/views/map/smallMap.vue